import { RuleHitRowItem } from "./RuleHitCard/types";
import { RuleDetails } from "./types";

export const ruleHitsFromMetadata = (data: { transaction_monitoring_rules: [] }) => {
  if (!data) {
    return [];
  }
  try {
    const ruleHits: RuleHitRowItem[] = data.transaction_monitoring_rules.map(
      (x: RuleDetails) => ({
        reason: x.ruleDetails.find((r) => r.name === "reason")?.value ?? [],
        details: x.ruleDetails.find((r) => r.name === "details")?.value ?? [],
      }),
    );
    return ruleHits;
  } catch {
    // return empty rule hits in case of bad data
    return [];
  }
};
